export default __webpack_public_path__ + "static/media/p2.ed913970.png";